import React from "react";
import "./TpPopUpCss.css";

const PopUpSubTitle = ({ subtitle, error, ...rest }) => {
  return <div className="popup-subtitle">{subtitle}</div>;
};

export default PopUpSubTitle;
